import {
  SET_TRAININGS_FILTER,
  SET_TRAININGS_FILTER_CRITERIA,
  CLEAR_TRAININGS_STATE
} from 'constants/reduceConstants';

const initialState = {
  filter: {},
  filterCriteria: {}
};

const trainingsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TRAININGS_FILTER:
      return { ...state, filter: payload };
    case SET_TRAININGS_FILTER_CRITERIA:
      return { ...state, filterCriteria: payload };
    case CLEAR_TRAININGS_STATE:
      return { ...initialState, filter: state.filter };
    default:
      return state;
  }
};

export default trainingsReducer;
